export default "__VITE_ASSET__3fE2aenk__"